module.exports = __webpack_public_path__ + "files/6126736fd90a86ed5a19831808ac7819.png";